import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["<i class=\"f7-icons icon color-orange\" style=\"font-size:15px\">star_fill</i>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base.js';
export default (function (props, _ref) {
  var $ = _ref.$,
      $h = _ref.$h,
      $tick = _ref.$tick,
      $update = _ref.$update,
      $f7 = _ref.$f7;

  var profile = function profile() {
    Base.profile();
  };

  var pagename = 'nvut';
  var rows,
      ngay = moment().format('YYYY-MM'),
      ngay_reverse = moment().format('MM-YYYY');
  var years = [];
  var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  var y = parseInt(moment().format('YYYY'));

  for (var i = 2; i > -1; i--) {
    var yy = y - i;
    years.push(yy);
  }

  var monthChosen = function monthChosen(picker) {
    var y = picker.cols[1].value;
    var m = picker.cols[0].value;

    if ("".concat(y, "-").concat(m) !== ngay) {
      ngay = "".concat(y, "-").concat(m);
      ngay_reverse = "".concat(m, "-").concat(y);
      rows = [];
      $update(function () {
        return list();
      });
    }
  };

  var changeMonth = function changeMonth(e) {
    var current = ngay.split('-');
    var picker = $f7.picker.create({
      inputEl: '#picker-input',
      toolbarCloseText: 'OK',
      value: [current[1], parseInt(current[0])],
      cols: [{
        values: months,
        displayValues: months
      }, {
        values: years,
        displayValues: years
      }],
      on: {
        close: function close(picker) {
          return monthChosen(picker);
        }
      }
    }).open();
  };

  var getHTML = function getHTML(is_nvut) {
    if (is_nvut) return $h(_templateObject());else return '';
  };

  var list = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Base.api('NhacNhoBaoCao', 'get_employee', {
                ngay: ngay
              });

            case 2:
              rs = _context.sent;
              rows = rs.rows;
              $update();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function list() {
      return _ref2.apply(this, arguments);
    };
  }();

  var actions = function actions(e) {
    var id = parseInt($(e.target).data('id'));
    var emp = rows.find(function (row) {
      return row.id === id;
    });
    $f7.actions.create({
      buttons: [{
        text: 'Nhắc nhở',
        onClick: function onClick() {
          $f7.views.main.router.navigate('/nvut-tieuchi-popup/', {
            props: {
              emp: emp
            }
          });
        }
      }, {
        text: 'Báo cáo',
        onClick: function onClick() {
          $f7.views.main.router.navigate('/nvut-baocao-popup/', {
            props: {
              emp: emp,
              ngay: ngay
            }
          });
        }
      }]
    }).open();
  };

  $tick(function () {
    list();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${pagename}">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Nhắc nhở</div>
      <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
    </div>
  </div>
  <div class="page-content">

    <div class="block margin-half">
      <div class="row text-align-center">
        <div class="col"><a class="button" href="/nvut-loinhac-popup/">Thêm lời nhắc</a></div>
        <div class="col"><a class="button" @click="${changeMonth}">${ngay_reverse}</a></div>
      </div>
    </div>

    <div class="list no-margin">
      <ul>
        ${rows && rows.map(row=>$h`
          <li key="${row.id}">
            <a class="item-link item-content">
              <div class="item-inner" data-id="${row.id}" @click="${actions}">${row.name} - ${row.nhacnho_count} ${getHTML(row.is_nvut)}</div>
            </a>
          </li>
        `)}
      </ul>
    </div>
  </div>
</div>
`
    }
    ;
});